var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 783.881H307L494.929 971.81C501.229 978.11 512 973.654 512 964.745V59.0091C512 50.1001 501.229 45.6529 494.929 51.9526L307 239.881H75C52.9086 239.881 35 257.79 35 279.881V743.881C35 765.973 52.9086 783.881 75 783.881ZM657.365 737.66L608 652.57V645.453C630.404 631.764 649.027 612.655 662.138 589.864C675.843 566.04 683.042 539.032 683.013 511.547C682.984 484.063 675.729 457.07 661.974 433.275C648.87 410.606 630.308 391.6 608 377.97V370.171L656.891 285.489C696.561 308.393 729.511 341.326 752.435 380.984C775.36 420.642 787.453 465.631 787.5 511.438C787.548 557.245 775.55 602.259 752.709 641.966C729.868 681.672 696.987 714.673 657.365 737.66ZM928.294 286.507C888.802 218.189 832.04 161.456 763.7 122L707.45 219.428C758.705 249.02 801.277 291.569 830.895 342.809C860.514 394.048 876.138 452.174 876.2 511.358C876.262 570.542 860.76 628.701 831.248 680.002C801.737 731.303 759.254 773.942 708.062 803.641L764.516 900.951C832.773 861.352 889.416 804.501 928.765 736.099C968.113 667.698 988.783 590.152 988.7 511.24C988.617 432.329 967.785 354.826 928.294 286.507Z",
    fill: "#0D38D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume);
export default __webpack_public_path__ + "static/media/icon-volume.3544539c1f25abd7b3f77449e232b63c.svg";
export { ForwardRef as ReactComponent };